import validationMessages from 'vee-validate/dist/locale/ru';
//citrix.ru

const yesNoOptions = [
    {value: "Yes", text: "Да"},
    {value: "No", text: "Нет"}
]

export default {
    privacyLinkLabel: "Политикой конфиден-циальности",
    privacyLink: '/ru-ru/about/legal/privacy/',
    privacyText: "Citrix будет обрабатывать ваши данные в соответствии со своей",
    resetText: "Если форма уже заполнена не вашими данными,",
    resetText2: "чтобы очистить ее.",
    resetLinkText: "нажмите здесь,",
    yes: "Да",
    no: "Нет",
    submitBtn: {
        "Submit" : "Отправить",
        "Get the eBook" : "Получить электронную книгу",
        "Watch demo" : "Watch demo",
        "Get the kit" : "Получить комплект ресурсов",
        "Compare now" : "Сравнить сейчас",
        "Request a demo": "Запросить демонстрацию",
        "Request a call": "Запросить звонок"
    },
    apjPrivacy:{
        title: "Использование персональных данных",
        company: "Citrix Systems Japan K.K.",
        part1: "(\"Citrix\") будет использовать и хранить ваши персональные данные в соответствии с действующими законами, нормами защиты данных и",
        linkText: "Политикой конфиденциальности Citrix,",
        part2: "а также в условиях строго ограниченного доступа. Citrix будет использовать ваши персональные данные в строгом соответствии с «Политикой конфиденциальности» и не будет использовать их для других целей. В соответствии со своей «Политикой конфиденциальности» Citrix может поручать обработку персональных данных отечественным или зарубежным юридическим лицам, делиться персональными данными с другими офисами или дочерними компаниями Citrix по всему миру либо отправлять персональные данные сторонним отечественным или зарубежным организациям. Отправляя свои персональные данные в компанию Citrix, вы соглашаетесь на их сбор и обработку в соответствии с «Политикой конфиденциальности Citrix.",
        privacyAccept: "Я ознакомился (-лась) и согласен (-на) с приведенной выше «Политикой конфиденциальности Citrix"
    },
    fields: {
        "AnnualSales": {
            label: "Annual Sales"
        },
        "Company_Self_Reported__c": {
            label: "Компания"
        },
        "department": {
            label: "Отдел",
            options: [
                { value: "Application Management", text: "Управление приложениями" },
                { value: "Consulting Services", text: "Консультирование" },
                { value: "Education / Training", text: "Обучение/тренинги" },
                { value: "Engineering", text: "Инженерное дело" },
                { value: "Executive Office / Administration", text: "Руководство/администрация" },
                { value: "Finance / Accounting", text: "Финансовая деятельность/бухгалтерский учет" },
                { value: "Human Resources", text: "Управление персоналом" },
                { value: "Information Technology - Systems", text: "Информационно-вычислительные системы" },
                { value: "Legal", text: "Юридическая информация" },
                { value: "Marketing / PR", text: "Маркетинг/связи с общественностью" },
                { value: "Networking", text: "Сетевые решения" },
                { value: "Operations / Manufacturing", text: "Операции/производство" },
                { value: "Pre-Sales / Technical Support", text: "Предварительная продажа/техническая поддержка" },
                { value: "Project Management", text: "Управление проектами" },
                { value: "Purchasing", text: "Закупки" },
                { value: "Sales / Bus-Corp Development", text: "Продажи/коммерческое-корпоративное развитие" },
                { value: "Security", text: "Безопасность" },
                { value: "Web / Online / E-Business", text: "Бизнес с применением интернет-технологий" }
            ]
        },
        "Industry_Self_Reported__c": {
            label: "Область",
            options: [
                { value: "Business Consulting", text: "Бизнес-консультирование" },
                { value: "Charitable/Non-Profit", text: "Благотворительность/некоммерческие организации" },
                { value: "Household Services", text: "Бытовые услуги" },
                { value: "Mining - All", text: "Горнодобывающая промышленность  — все отрасли" },
                { value: "Hospitality", text: "Гостиничный бизнес" },
                { value: "Government/National-Federal", text: "Государственное и федеральное правительство" },
                { value: "Health Care", text: "Здравоохранение" },
                { value: "Publishing/Printing", text: "Издательское дело/полиграфия" },
                { value: "Engineering", text: "Инженерное дело" },
                { value: "Art & Membership", text: "Искусство и членство в организациях" },
                { value: "Utilities", text: "Коммунальные услуги" },
                { value: "Government/Local", text: "Местные органы власти" },
                { value: "Conglomerate", text: "Многопрофильная организация" },
                { value: "Real Estate", text: "Недвижимость" },
                { value: "Oil and Gas", text: "Нефтегазовая промышленность" },
                { value: "Education", text: "Образовательные учреждения" },
                { value: "Service Provider", text: "Поставщик услуг" },
                { value: "Government/State-Province", text: "Правительство областей или регионов" },
                { value: "Manufacturing", text: "Производство" },
                { value: "Professional Services", text: "Профессиональные услуги" },
                { value: "Entertainment", text: "Развлечения" },
                { value: "Retail/Wholesale", text: "Розничная/оптовая торговля" },
                { value: "Agriculture", text: "Сельское хозяйство" },
                { value: "Insurance", text: "Страхование" },
                { value: "Construction and Design", text: "Строительство и проектирование" },
                { value: "Telecommunication", text: "Телекоммуникации" },
                { value: "Technology", text: "Технологии" },
                { value: "Consumer Packaged Goods", text: "Товары народного потребления" },
                { value: "Transportation", text: "Транспорт" },
                { value: "Personnel Services", text: "Управление персоналом" },
                { value: "Business/Personal Services", text: "Услуги предприятиям/услуги частным лицам" },
                { value: "Pharmaceuticals", text: "Фармацевтика" },
                { value: "Finance", text: "Финансирование" },
                { value: "Chemical Manufacturing", text: "Химическое производство" },
                { value: "E-Commerce", text: "Электронная торговля" },
                { value: "Legal", text: "Юридическая информация" }
            ]
        },
        "NumberOfEmployees_Self_Reported__c" : {
            label: "Размер компании",
            options: [
                { value: "50", text: "1-50" },
                { value: "500", text: "51-500" },
                { value: "749", text: "501-749" },
                { value: "4999", text: "750-4,999" },
                { value: "19999", text: "5,000-19,999" },
                { value: "20000", text: "20,000+" }
            ]
        },
        "NumberofEmployees__here___atlocation": {
            label: "Размер компании",
            options: [
                { value: "5,001 +", text: "5 001 +" },
                { value: "1,001 to 5,000", text: "От 1 001 до 5 000" },
                { value: "501 to 1,000", text: "От 501 до 1 000" },
                { value: "251 to 500", text: "От 251 до 500" },
                { value: "1 to 250", text: "От 1 до 250" }
            ]
        },
        "Address2": {
            label: "Строка адреса 2"
        },
        "Address3": {
            label: "Строка адреса 3"
        },
        "city": {
            label: "Город"
        },
        "country": {
            label: "Страна"
        },
        "email": {
            label: "Рабочий адрес электронной почты"
        },
        "firstName": {
            label: "Имя"
        },
        "lastName": {
            label: "Фамилия"
        },
        "phone": {
            label: "Номер телефона"
        },
        "mobilePhone": {
            label: "Mobile Phone"
        },
        "postalCode": {
            label: "Индекс/почтовый код"
        },
        "salutation": {
            label: "Приветствие",
            options: [
                { value: "", text: ""},
                { value: "Dr.", text: "Dr."},
                { value: "Egr. Sig.", text: "Egr. Sig."},
                { value: "Frau", text: "Frau"},
                { value: "Gent.ma Sig.ra", text: "Gent.ma Sig.ra"},
                { value: "Herr", text: "Herr"},
                { value: "Madame", text: "Madame"},
                { value: "Mademoiselle", text: "Mademoiselle"},
                { value: "Miss", text: "Miss"},
                { value: "Monsieur", text: "Monsieur"},
                { value: "Mr.", text: "Mr."},
                { value: "Mrs.", text: "Mrs."},
                { value: "Ms.", text: "Ms."},
                { value: "Professor", text: "Professor"},
                { value: "Señor", text: "Señor"},
                { value: "Señora", text: "Señora"}
            ]
        },
        "state": {
            label: "Штат/провинция"
        },
        "address": {
            label: "Адрес"
        },
        "Job_Title__c": {
            label: "Должность",
            options: [
                { value: "Network Administrator / Engineer", text: "Администратор сети/инженер" },
                { value: "Analyst", text: "Аналитик" },
                { value: "Architect", text: "Архитектор" },
                { value: "Assistant", text: "Ассистент" },
                { value: "Owner / Partner", text: "Владелец/партнер" },
                { value: "Director", text: "Директор" },
                { value: "Business Manager", text: "Коммерческий директор" },
                { value: "Consultant", text: "Консультант" },
                { value: "Developer / Programmer", text: "Разработчик/программист" },
                { value: "C-Level / President / VP", text: "Руководитель высшего звена/президент/вице-президент" },
                { value: "IT Manager", text: "Руководитель по ИТ" },
                { value: "System Administrator", text: "Системный администратор" },
                { value: "Student", text: "Студент" }
            ]
        },
        "Project_Budget__c": {
            label: "Бюджет проекта",
            options: [
                { value: "Yes", text: "Да" },
                { value: "No", text: "Нет" },
                { value: "Unknown", text: "Неизвестен" }
            ]
        },
        "Primary_Product_Interest__c": {
            label: "CTRL для выбора более одной опции (максимально можно выбрать 5)"
        },
        "Purchase_Timeframe__c": {
            label: "Время покупки",
            options: [
                { value: "3 months or less", text: "3 месяца или менее" },
                { value: "4 to 6 months", text: "От 4 до 6 месяцев" },
                { value: "7 months or more", text: "7 месяцев или более" },
                { value: "No time frame", text: "Нет временных рамок" },
                { value: "Unknown", text: "Не определено" }
            ]
        },
        "Email_Blast_OK__c": {
            label: "Можем ли мы отправлять вам сообщения по электронной почте?",
            options: [
                { value: "Yes", text: "Да" },
                { value: "No", text: "Нет" }
            ]
        },
        "Direct_Mail_OK__c": {
            label: "May we contact you by mail?",
            options: [
                { value: "Yes", text: "Да" },
                { value: "No", text: "Нет" }
            ]
        },
        "OK_to_Call__c": {
            label: "Можем ли мы звонить вам по телефону?",
            options: [
                { value: "Yes", text: "Да" },
                { value: "No", text: "Нет" }
            ]
        },
        "Preferred_Language__c": {
            label: "Preffered language"
        },
        "Sales_Contact_Requested__c": {
            label: "Прошу торгового представителя связаться со мной"
        },
        "Comments_6__c":{
            label: "Комментарии"
        },
        //PrefCenter fields/options
        "Unsubscribed": {
            label: "Отказаться от подписки на все рекламные сообщения электронной почты.",
            options: [...yesNoOptions]
        },
        "Marketing_Suspended_30_Days__c": {
            label: "Приостановить отправку сообщений на 30 дней.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_Workspace__c": {
            label: "Как полноценные цифровые рабочие места, включающие приложения, десктопы, файлы и мобильные устройства, помогают вам выполнять работу максимально эффективно откуда угодно.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_VirtualAppsDesktops__c": {
            label: "Как обеспечить безопасный доступ ко всем приложениям, десктопам и данным с любого устройства.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_NetworkingADC__c": {
            label: "Как управлять доставкой монолитных и микросервисных приложений в гибридной многооблачной среде.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_SDWan__c": {
            label: "Как обеспечить постоянный доступ к сети, необходимый вашим пользователям, а также ее высокую производительность.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_Analytics__c": {
            label: "Как выявлять и предотвращать угрозы безопасности и аномалии в производительности приложений с помощью аналитики и сводной информации.",
            options: [...yesNoOptions]
        }
    },
    optOut: {
        formTitle: "Отказаться от подписки",
        thankyou: "Ваши настройки электронной почты изменены. Если это было сделано по ошибке или если вы хотите просмотреть настройки, вы можете в любое время зайти в Центр настроек.",
        formDescription: "Нам жаль, что вы нас покидаете. Просим вас иногда заходить на сайт citrix.ru. Мы постоянно добавляем новые функции и возможности, чтобы гарантировать эффективную работу продуктов Citrix в вашей среде.",

    },
    preferenceCenter: {
        formTitle: "Центр настроек электронной почты Citrix",
        thankyou: "<h3>Изменение настроек подписки подтверждено!</h3><p>Ваши настройки электронной почты изменены.</p>",
        formDescription: "Ваши предпочтения в отношении электронной почты и рассылок важны для нас. Мы хотим отправлять вам информацию, которая поможет вам и вашей организации сделать работу эффективнее.  Обновите свои настройки электронной почты, чтобы мы могли отправлять вам важные для вас сообщения от Citrix.",
        labelOne: "Расскажите о себе подробнее",
        labelTwo: "Какие темы вас интересуют?",
        labelThree: "Каким способом с вами лучше связываться?",
    },
    validation: validationMessages
}